'use strict';

module.exports = {
    UNAVIALABLE_SERVICE: 'Layanan tidak tersedia, silakan coba lagi nanti.',
    NEED_ACTIVE: 'Akun Anda {{account}} menggunakan situs web ini untuk pertama kalinya. Silakan {{activeLink}} untuk menyelesaikan aktivasi dan kembali ke halaman ini untuk melanjutkan operasi',
    GOTO_ACTIVE: 'Aktifkan sekarang',
    NOT_ACTIVED: 'Akun belum berhasil diaktifkan, harap {{activeLink}} untuk menyelesaikan aktivasi',
    COMPLETE_ACTIVE: 'Konfirmasi aktivasi',
    FORBID_ACTIVE: 'Akun ini tidak didukung di AliExpress!',
    SIGN_UP_WITH_ANOTHER_ACCOUNT: 'Silakan masuk dengan akun lain',
    ACTIVE_PAGE: 'Kunjungi halaman aktivasi akun'
};